define(['jquery', 'marionette', 'components/attachments-middleware', '../templates/attachment.html'],
  function ($, Marionette, attachmentHandler, tmplAttachment) {
    return Marionette.ItemView.extend({
      template: tmplAttachment,

      tagName: 'li',

      ui: {
        input_attachment: '.input_attachment',
        check_attachment: '.js-check',
        del: '.js-delete',
        file_attachment: '.file-attachment'
      },

      events: {
        'click @ui.del': 'deleteAttachment',
        'change @ui.check_attachment': 'changeStatus'
      },

      modelEvents: {
        change: 'render'
      },

      options: {
        isAttachment: true,
        labels: {
          loading: '... Loading ...'
        }
      },

      className: function () {
        return 'add-attachment attachment--' + this.model.get('type')
      },

      deleteAttachment: function (e) {
        var self = this
        e.preventDefault()
        self.model.collection.remove(self.model)
        return false
      },

      changeStatus: function () {
        this.options.isAttachment = !!this.ui.check_attachment.prop('checked')
        this.setAttachment()
      },

      setAttachment: function () {
        if (this.options.isAttachment && this.model.isLoaded()) {
          this.setValue()
          attachmentHandler({ el: this.ui.file_attachment })
        } else if (this.ui.input_attachment) {
          this.ui.input_attachment.val('')
        }
      },

      onRender: function () {
        this.setAttachment()
      },

      templateHelpers: function () {
        return {
          labels: this.options.labels,
          isAttachment: this.options.isAttachment,
          model: this.model.toJSON(),
          formData: this.getFormData(),
          isLoaded: this.model.isLoaded(),
          input_name: this.options.input_name
        }
      },

      getFormData: function () {
      // provides clean data for form submit (rendered in template as <input>)
        var data = this.model.toJSON()
        if (data.id && !$.isNumeric(data.id)) delete data.id
        delete data.__id
        return JSON.stringify(data)
      },

      setValue: function () {
        this.ui.input_attachment.val(this.getFormData())
      }
    })
  })
